import { DetailResponseData, ListResponseData, QueryParams } from "./base";
import { Institution } from "./institution";

export type InstitutionRankingValue = 1 | 2 | 3;
export type InstitutionRankingLabel = "Positive" | "Neutral" | "Negative";

export const rankValueOptions: Array<{
  label: InstitutionRankingLabel;
  value: InstitutionRankingValue;
}> = [
  { label: "Positive", value: 1 },
  { label: "Neutral", value: 2 },
  { label: "Negative", value: 3 },
];

export interface InstitutionRankingListItem {
  created_at: string;
  id: string;
  institution: Institution;
  note: string;
  rank_value: InstitutionRankingValue;
  user: {
    id: string;
  };
}

export interface InstitutionRanking {
  created_at: string;
  institution_id: string;
  institution_ranking_id: string;
  note: string;
  rank: string;
  rank_value: InstitutionRankingValue;
  refreshed_at: string;
}

export interface InstitutionRankingListQueryParams extends QueryParams {
  fInstitutionId?: string;
  fCreatedBy?: string;
}

export interface InstitutionRankingListResponseData extends ListResponseData<InstitutionRankingListItem> {}

export interface InstitutionRankingDetailResponseData extends DetailResponseData<InstitutionRanking> {}

export interface CreateInstitutionRankingPayload {
  institution: string;
  rank_value: InstitutionRankingValue;
  note: string;
}

export interface UpdateInstitutionRankingPayload {
  institution: string;
  rank_value: InstitutionRankingValue;
  note: string;
}

export interface CreateInstitutionRankingUserPayload {
  institution: string;
  custom_rank_value: number;
}

export interface InstitutionRankingUser {
  calculated_rank_value: number;
  created_at: string;
  custom_rank_value: number;
  id: string;
  institution: {
    id: string;
    name: string;
  };
  user: {
    email: string;
    id: string;
  };
}

export interface InstitutionRankingUserListResponseData extends ListResponseData<InstitutionRankingUser> {}
